<section>
  <div class="header"><h1>Debug Help</h1></div>

  <h4>Mapping issues</h4>
  <div class="stackinfo">
    <table>
      @for (ex of mappingExceptions; track ex) {
        <tr>
          <td>{{ ex.value }}</td>
          <td>{{ ex.key }}</td>
        </tr>
      }
    </table>
  </div>
</section>
